const businessStore = {
  state: {
    bussiness: null,
  },
  reducers: {
    SET_BUSINESS(state, payload) {
      return {
        bussiness: payload,
      };
    },
  },
  effects: (dispatch) => ({
    addBussiness(payload) {
      dispatch.bussiness.SET_BUSINESS(payload);
    },
    async fetchAndSetBussiness(_payload, rootState) {
      try {
        const merchantAccount = rootState?.auth?.user?.merchantAccount;
        if (merchantAccount) {
          dispatch.bussiness.SET_BUSINESS(merchantAccount);
        }
      } catch (error) {
        console.log(
          'error in [businessStore]::fetchAndSetBussiness::error',
          error,
        );
        throw error;
      }
    },
  }),
};

export default businessStore;
